import { TableData } from "./TableData";

export class ViewDataModel {
  public summaryData: SummaryData[];
  public isAllDataMode: boolean;

  constructor() {
    this.summaryData = new Array<SummaryData>();
  }
}

export class SummaryData {
  public tableData: TableData;
  public imageId: string;
  public fileName: string;
}
